<template>
  <BaseCard
    v-if="timelineItems && timelineItems.length"
    :heading="$t('global.history')"
    v-test="'invoice-history'"
  >
    <Timeline :data="timelineItems" />
  </BaseCard>
</template>

<script lang="ts">
import gql from 'graphql-tag';
import { defineComponent } from 'vue';
import Timeline from '@/components/Timeline.vue';

export default defineComponent({
  components: {
    Timeline,
  },
  apollo: {
    timelineItems: {
      query: gql`
        query getTimelineItems($recordId: ID!, $recordType: RecordType) {
          timelineItems(recordId: $recordId, recordType: $recordType) {
            changes
            createdAt
            customer {
              firstName
            }
            id
            key
            meta
            user {
              fullName
              id
              email
            }
          }
        }
      `,
      variables() {
        return {
          recordId: this.orderId,
          recordType: 'ORDER',
        };
      },
      skip() {
        return !this.orderId;
      },
    },
  },
  computed: {
    orderId() {
      return this.$route.params.id;
    },
  },
});
</script>
